import { render, staticRenderFns } from "./Regulations.vue?vue&type=template&id=7e997375&scoped=true"
var script = {}
import style0 from "./Regulations.vue?vue&type=style&index=0&id=7e997375&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e997375",
  null
  
)

export default component.exports